import styled, { css } from 'styled-components';
import is from 'styled-is';

import media from './media';

const mediaKeys = Object.keys(media);

const getColor = (props) => {
  const color = props.theme.base.colorSchema[props.cellColor];
  return color ? color : 'red';
};

const responsiveStyles = (prop, fn) => (props) => {
  const propValue = props[prop];
  if (typeof propValue === 'number') {
    return css([fn(propValue)]);
  }

  if (typeof propValue === 'string') {
    const [big, ...sizes] = propValue.split(',');
    return css`
      ${fn(big)}
      ${sizes.map((value, key) =>
        value && mediaKeys[key] ? media[mediaKeys[key]]`${fn(value)}` : ''
      )}
    `;
  }
};

const spacingMap = {
  mTop: 'margin-top',
  mRight: 'margin-right',
  mBottom: 'margin-bottom',
  mLeft: 'margin-left',
  pTop: 'padding-top',
  pRight: 'padding-right',
  pBottom: 'padding-bottom',
  pLeft: 'padding-left',
  p: 'padding',
  m: 'margin',
};

const spacingKeys = Object.keys(spacingMap);

export const spacingProps = ({ theme, ...props }) => {
  return css([
    spacingKeys.map((key) => {
      const propValue = props[key];
      const compiledCss =
        propValue &&
        responsiveStyles(
          key,
          (value) => `${spacingMap[key]}: ${theme.base.gridSizes[value]};`
        )(props);
      return compiledCss;
    }),
  ]);
};

const weightProps = ({ fontWeight = '500' }) => css`
  font-weight: ${fontWeight};
`;

const CardCell = styled.div`
  align-items: center;
  white-space: nowrap;

  ${weightProps}

  ${is('cellHeight')`
    height: ${(props) => `${props.cellHeight}`};
  `}

  ${is('cellGrow')`
    flex: 1 0 100%;
  `}

  ${is('cellPush')`
    flex: 1;
  `}

  ${is('alignRight')`
    text-align: right;
    > button{
      text-align: right;
    }
  `}

  ${responsiveStyles(
    'cellWidth',
    (value) => `
      ${value === '0' ? 'display: none;' : `flex: 0 0 ${value}px;`}
    `
  )}

  ${responsiveStyles(
    'cellMaxWidth',
    (value) => `
      max-width: ${value}px;
    `
  )}

  ${responsiveStyles(
    'cellMinWidth',
    (value) => `
      min-width: ${value}px;
    `
  )}

  ${is('cellOverflow')`
    overflow: hidden;
    text-overflow: ellipsis;
    > * {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `}

  ${is('cellColor')`
    color: ${getColor};
  `}

  ${is('cellParent')`
    display: flex;
  `}

  ${is('boldText')`
    font-weight: bold;
  `}

  ${spacingProps}
`;

export default CardCell;
